import axios from 'axios';
// Não precisa mais importar API_BASE_URL, pois vamos usar a URL fixa

// Instância centralizada do axios para todas as chamadas de API
const api = axios.create({
  baseURL: '/api'
});

// Interceptor para adicionar o token em todas as requisições
api.interceptors.request.use(config => {
  const token = localStorage.getItem('@Emprestimos:token');
  console.log('[API] Token encontrado:', token ? 'Sim' : 'Não');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('[API] Headers configurados:', config.headers);
  }
  return config;
});

// Interceptor para tratamento global de erros (opcional)
api.interceptors.response.use(
  response => response,
  error => {
    console.error('[API] Erro na requisição:', error);
    if (error.response) {
      console.error('[API] Resposta do servidor:', error.response.data);
      console.error('[API] Status:', error.response.status);
      console.error('[API] Headers:', error.response.headers);
    }
    return Promise.reject(error);
  }
);

export default api;

export const listarAportes = (idEmprestimo) =>
  api.get(`/emprestimos/${idEmprestimo}/aportes`);

export const adicionarAporte = (idEmprestimo, data) =>
  api.post(`/emprestimos/${idEmprestimo}/aportes`, data);